import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../enums'

const FUNCTIONALIZATION_INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Functionalization,
    graphql.schema.SpaceFunctionalizationInput
  >({
    functionId: transformers.PASS_THROUGH,
    percent: transformers.PASS_THROUGH,
  }),
)

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Organization.UpdateJointUse,
    graphql.schema.OrganizationJointUseUpdate
  >({
    calculationMode: graphql.transformers.IN.nonNull(
      enums.calculationMode.TRANSFORMER,
    ),
    manualFunctionalizations: {
      usingFullInput: graphql.transformers.IN.if(
        (update: ents.extra.space.Organization.UpdateJointUse) =>
          ents.extra.space.Organization.JointUseCalculationMode.isManual(
            update.calculationMode,
          ),
        graphql.transformers.IN.select(
          'manualFunctionalizations',
          graphql.transformers.IN.list(
            graphql.transformers.IN.if(
              (f: ents.extra.space.Functionalization) => f.percent !== 0,
              FUNCTIONALIZATION_INPUT,
              graphql.transformers.IN.always(undefined),
            ),
            { onNullish: 'remove' },
          ),
        ),
        graphql.transformers.IN.always(undefined),
      ),
    },
  }),
)
